import Auth from '@/components/auth/Auth'
import PageNotFound from '@/views/PageNotFound'
import Home from '@/views/Home'

import categoryRoutes from './category'
import brandRoutes from './brand'
import languageRoutes from './language'
import gameRoutes from './game'
import territoryRoutes from './territory'
import gameOrderRoutes from './game-order'

const routes = [
  {
    path: '/callback',
    name: 'Auth',
    component: Auth,
    props: {
      pageTitle: 'Authenticating'
    }
  },
  {
    path: '',
    name: 'Home',
    component: Home,
    props: {
      pageTitle: 'Home'
    }
  },
  {
    path: '*',
    name: 'Page-not-found',
    component: PageNotFound,
    props: {
      pageTitle: 'Error 404 Page not found'
    }
  },
  ...categoryRoutes,
  ...brandRoutes,
  ...languageRoutes,
  ...gameRoutes,
  ...territoryRoutes,
  ...gameOrderRoutes
]

export default routes
